import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { LightController } from '../../controllers/light-controller';
import { OutlineElement } from '../../base/outline-element/outline-element';
import globalComponentStyles from './ghs-bellin-search-form.global.css.lit';
import componentStyles from './ghs-bellin-search-form.css.lit';

/**
 * The GHS Bellin Search Form component
 */
@customElement('ghs-bellin-search-form')
export class GhsBellinSearchForm extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  lightController = new LightController(
    this,
    [globalComponentStyles],
    this.tagName.toLowerCase()
  );

  render(): TemplateResult {
    const classes = {
      'ghs-bellin-search-form': true,
    };

    return html` <div class="${classMap(classes)}"><slot></slot></div>`;
  }
}
